var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFindBoutique(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "14px",
    height: "17px",
    viewBox: "0 0 14 17",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Find boutique") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "04-D---CDP",
    transform: "translate(-1303.000000, -24.000000)",
    fill: "#000000"
  }, /*#__PURE__*/React.createElement("g", {
    id: "First-level-menu",
    transform: "translate(32.000000, 14.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Find-boutique",
    transform: "translate(1271.000000, 10.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,0.822580645 C3.62280702,0.822580645 0.921052632,3.23548387 0.921052632,6.2516129 C0.921052632,8.88387097 5.64912281,14.2032258 7,15.683871 C8.35087719,14.2032258 13.0789474,8.88387097 13.0789474,6.2516129 C13.0789474,3.29032258 10.377193,0.822580645 7,0.822580645 L7,0.822580645 Z M7,17 L6.63157895,16.616129 C6.38596491,16.3419355 0,9.59677419 0,6.2516129 C0,2.8516129 3.13157895,0 7,0 C10.8684211,0 14,2.79677419 14,6.2516129 C14,9.59677419 7.61403509,16.2870968 7.36842105,16.5612903 L7,17 Z",
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7,7 C6.46000969,7 6,6.55975758 6,5.99975758 C6,5.46012121 6.44013572,5 7,5 C7.55986428,5 8,5.44024242 8,5.99975758 C8,6.55975758 7.53950557,7 7,7",
    id: "Fill-3"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFindBoutique);
export default __webpack_public_path__ + "static/media/find-boutique.964422240ad8634210075340798ba355.svg";
export { ForwardRef as ReactComponent };